import { useState } from "react";

const STATUS_OPTS = [
  ["PLANNING", "Planning"],
  ["ACTIVE", "Active"],
  ["ON_HOLD", "On Hold"],
  ["COMPLETED", "Completed"],
  ["ARCHIVED", "Archived"],
];

const PRIORITY_OPTS = ["CRITICAL", "HIGH", "MEDIUM", "LOW", "SOMEDAY"];

export default function StoryFormModal({ story, onSave, onClose }) {
  const isEdit = !!story;
  const [form, setForm] = useState({
    name:        story?.name        || "",
    description: story?.description || "",
    status:      story?.status      || "PLANNING",
    priority:    story?.priority    || "MEDIUM",
    targetDate:  story?.targetDate  || "",
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    onSave({
      ...form,
      targetDate: form.targetDate || null,
    });
  };

  return (
    <div className="proj-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="proj-modal">
        <div className="proj-modal-header">
          <h3>{isEdit ? "Edit Story" : "New Story"}</h3>
          <button className="proj-modal-close" onClick={onClose}>✕</button>
        </div>
        <form className="proj-modal-body" onSubmit={handleSubmit}>
          <div className="proj-form-group">
            <label>Name *</label>
            <input className="proj-input" required autoFocus value={form.name}
                   onChange={e => set("name", e.target.value)} placeholder="e.g. Password reset flow" />
          </div>

          <div className="proj-form-group">
            <label>Description</label>
            <textarea className="proj-textarea" rows={3} value={form.description}
                      onChange={e => set("description", e.target.value)}
                      placeholder="What does this story cover? Acceptance criteria?" />
          </div>

          <div className="proj-form-row">
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Status</label>
              <select className="proj-select" value={form.status} onChange={e => set("status", e.target.value)}>
                {STATUS_OPTS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
              </select>
            </div>
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Priority</label>
              <select className="proj-select" value={form.priority} onChange={e => set("priority", e.target.value)}>
                {PRIORITY_OPTS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Target Date</label>
              <input type="date" className="proj-input" value={form.targetDate || ""}
                     onChange={e => set("targetDate", e.target.value)} />
            </div>
          </div>

          <div className="proj-modal-footer">
            <button type="button" className="proj-btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="proj-btn-primary">{isEdit ? "Save Changes" : "Create Story"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
